<template>
  <div class="voucher-expiration">
    <div v-if="date">{{ formattedDate }}</div>
    <span v-else>—</span>
    <span v-if="status"
          class="voucher-expiration__badge"
          :class="'voucher-expiration__badge--' + status.level"
          v-b-tooltip.hover
          title="Estado del vencimiento">
      {{ status.label }}
    </span>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      date: {
        type: [String, Date],
        default: null,
      },
      pending: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      formattedDate() {
        return moment(this.date).format('DD/MM/YYYY')
      },
      status() {
        if(!this.pending || !this.date) return null

        const today = moment().startOf('day')
        const expiration = moment(this.date).startOf('day')
        if(!expiration.isValid()) return null

        const days = expiration.diff(today, 'days')
        if(days < 0) {
          return { level: 'overdue', label: days === -1 ? 'Vencida ayer' : 'Vencida hace ' + Math.abs(days) + ' días' }
        }
        if(days === 0) return { level: 'today', label: 'Vence hoy' }
        if(days <= 7) return { level: 'week', label: 'Vence en ' + days + ' día' + (days === 1 ? '' : 's') }
        if(days <= 15) return { level: 'fortnight', label: 'Vence en ' + days + ' días' }
        if(days <= 30) return { level: 'month', label: 'Vence en ' + days + ' días' }
        return null
      },
    },
  }
</script>

<style scoped>
  .voucher-expiration__badge {
    display: inline-flex;
    align-items: center;
    margin-top: 3px;
    padding: 2px 5px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.15;
    white-space: nowrap;
  }
  .voucher-expiration__badge--overdue,
  .voucher-expiration__badge--today {
    border-color: var(--app-color-danger-border);
    background: var(--app-color-danger-soft);
    color: var(--app-color-danger-hover);
  }
  .voucher-expiration__badge--week {
    border-color: var(--app-color-warning-border);
    background: var(--app-color-warning-soft);
    color: var(--app-color-warning-hover);
  }
  .voucher-expiration__badge--fortnight {
    border-color: var(--app-color-info-border);
    background: var(--app-color-info-soft);
    color: var(--app-color-primary-active);
  }
  .voucher-expiration__badge--month {
    border-color: var(--app-color-success-border);
    background: var(--app-color-success-soft);
    color: var(--app-color-success-hover);
  }
</style>
